import type { Theme } from '@mui/material';

export const styles = {
  topicHint: (theme: Theme) => ({
    color: theme.colors.primary[500],
    backgroundColor: theme.colors.primary[50],
    alignSelf: 'center',
  }),

  subTopicHint: (theme: Theme) => ({
    ...theme.typography.caption2,
    color: theme.colors.primary[500],
    backgroundColor: theme.colors.primary[50],
    justifyContent: 'center',
    px: 1.5,
    py: 0,
  }),

  linkageHint: (theme: Theme) => ({
    color: theme.colors.primary[500],
    backgroundColor: theme.colors.neutral[50],
    alignSelf: 'flex-end',
    position: 'relative',
  }),

  insightWheel: (theme: Theme) => ({
    flexDirection: 'column',

    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
    },
  }),
};
